import React from 'react';
import '../App.css';
import { Button, SectionHeader, Footer } from 'design-system-idm';
import TwitterLogo from '../assests/logo-twitter.png';
import FBLogo from '../assests/logo-fb.png';
import InstaLogo from '../assests/logo-insta.png';
import IconLetter from '../assests/icon-letter.svg';
import IconSlide from '../assests/icon-slide.svg';
import IconBouy from '../assests/icon-bouy.svg';
import IconPlant from '../assests/icon-plant.svg';
import IconLight from '../assests/icon-lightbulb.svg'
import Map from '../assests/map.png';

function Locations() {
  return (
    <div className="location">
    <div className="wrap">
      <div className="pad-left width-50 mar-bot-3">
        <h1>Our Locations</h1>
          <p>From rec centers and parks to historic and cultural attractions, there are hundreds of places to go. Explore all of Philadelphia Parks & Recreation’s locations.</p>
      </div>
      <SectionHeader
      title="Places to go"
      BCKGDcolor="#8CD9DE"/>
      <div className="flex">
        <div className="pad-left width-80 mar-bot-3">
          <Button btnStyle="btn-icon"
           borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
              <img src={IconSlide}alt="slide icon"></img>
              Playgrounds and courts
          </Button>
          <Button btnStyle="btn-icon"
           borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
              <img src={IconLetter}alt="letter icon"></img>
              Historic and cultural attractions
          </Button>
          <Button btnStyle="btn-icon"
           borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
              <img src={IconBouy}alt="letter icon"></img>
              Swimming pools
          </Button>
          <Button btnStyle="btn-icon"
           borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
              <img src={IconPlant}alt="letter icon"></img>
              Environmental education centers
          </Button>
          <Button btnStyle="btn-icon"
           borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
              <img src={IconLetter}alt="letter icon"></img>
              Recycling centers
          </Button>
          <Button btnStyle="btn-icon"
           borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
              <img src={IconLight}alt="letter icon"></img>
              Computer labs
          </Button>
        </div>
        <img src={Map} alt="map" className="map"></img>
      <div className="pad-bot-3"></div>
      </div>

     </div>
     <Footer
      BCKGDcolorLinks="#15AF53"
      BCKGDcolorContact="#03944f"
      links={[{
          href: "#",
          text: "Documents and forms"
        },{
          href: "#",
          text: "Press Releases"
        },{
          href: "#",
          text: "Rules and regulations"
        },{
          href: "#",
          text: "Fairmount Park Conservancy"
        },{
          href: "#",
          text: "Philadelphia Parks Alliance"
        },
      ]}
      address="1515 Arch Street, Philadelphia, PA 19102"
      email="parksandrecreation@phila.gov"
      phone="(215) 683-3600"
      logoTwitter={TwitterLogo}
      logoFB={FBLogo}
      logoInsta={InstaLogo}
      />
    </div>
  );
}

export default Locations;
